import { Injectable } from '@angular/core';
import { FeatureTogglesFacade } from '@cigna/features';
import { ChatBubbleOpen } from '@cigna/omni/chat-state';
import { OmniConversationsFacade } from '@cigna/omni/conversations-state';
import { OmniLiveAvailabilityFacade } from '@cigna/omni/live-availability-state';
import { StartChat } from '@cigna/omni/right-now-data-access';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { filter, map, withLatestFrom } from 'rxjs/operators';
import { BubbleClick, ChatBubbleActionTypes } from './chat-bubble.actions';

@Injectable()
export class ChatBubbleEffects {
  chatBubbleClick$ = createEffect(() =>
    this.actions$.pipe(
      ofType<BubbleClick>(ChatBubbleActionTypes.BubbleClick),
      withLatestFrom(
        this.featureTogglesFacade.featuresEnabled(['useRightNowChat']),
        this.liveAvailabilityFacade.liveChatAvailable$,
        this.featureTogglesFacade.featuresEnabled(['rightNowChatFederated']),
        this.conversationsFacade.activeChatProvider$,
        this.featureTogglesFacade.featuresEnabled(['eapGreenBubble']),
      ),
      filter(
        ([_, useRightNowChat, liveChatAvailable, eapGreenBubble]) =>
          // restrict bubble click for users without live chat and with right now chat enabled and eap green bubble indicator turned off
          liveChatAvailable || !useRightNowChat || eapGreenBubble,
      ),
      map(
        ([
          _,
          useRightNowChat,
          _liveChatAvailable,
          rightNowChatFederated,
          activeChatProvider,
          eapGreenBubble,
        ]) =>
          // activeChatProvider is needed only when rightNowChatFederated feature is turned on
          useRightNowChat && !eapGreenBubble
            ? new StartChat(rightNowChatFederated ? activeChatProvider : '')
            : new ChatBubbleOpen(),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private featureTogglesFacade: FeatureTogglesFacade,
    private liveAvailabilityFacade: OmniLiveAvailabilityFacade,
    private conversationsFacade: OmniConversationsFacade,
  ) {}
}
